import { createRoot } from 'react-dom/client';

import App from './App';
import { ErrorBoundary } from '@/components/error-boundary';

import './index.css';

const sourcemapProbe = new URLSearchParams(window.location.search).get(
  'sourcemap-probe',
);

function triggerPublishedSourcemapProbe() {
  throw new Error('SHER_SOURCEMAP_PROBE');
}

if (sourcemapProbe === 'browser-error') {
  window.setTimeout(triggerPublishedSourcemapProbe, 0);
}

createRoot(document.getElementById('root')!, {
  // Keeps caught errors off reportError(), which would raise the dev overlay.
  onCaughtError: (error, errorInfo) => {
    console.error(error, errorInfo.componentStack);
  },
}).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
